import React from 'react';
import { Route } from 'react-router-dom';
// eslint-disable-next-line no-unused-vars
import MasterTableChild from './MasterTableChild';
import OtherAsset from './OtherAsset';
import { MasterTableType } from '../../const';


export default function MasterTable({ match }) {
    return (
        <div className="content">
            <div className="container-fluid">
                <Route path={`${match.url}/party-type`} component={() => <MasterTableChild type={MasterTableType.party_type} />} />
                <Route path={`${match.url}/business-sector`} component={() => <MasterTableChild type={MasterTableType.business_sector} />} />
                <Route path={`${match.url}/loan-purpose-type`} component={() => <MasterTableChild type={MasterTableType.loan_purpose_type} />} />
                <Route path={`${match.url}/collateral-master`} component={() => <MasterTableChild type={MasterTableType.collateral_master} />} />
                <Route path={`${match.url}/other-assets`} component={() => <OtherAsset type={MasterTableType.other_assets} />} />
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// src/pages/MasterTable/index.js